import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerComponiFatturaPRConfirmModalComponent } from './worker-componi-fattura-pr-confirm-modal';

export const WorkerComponiFatturaPRConfirmModalModule: string = ng
    .module('worker-componi-fattura-pr-confirm-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerComponiFatturaPRConfirmModalComponent', WorkerComponiFatturaPRConfirmModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/worker-componi-fattura-pr-confirm-modal/worker-componi-fattura-pr-confirm-modal.module.ts